import { create } from "zustand";

/**
 * 패널의 열림 상태와 **페이지 공유** 토글입니다. 둘 다 화면 사이를 건너다니는
 * 값이라 라우트에 두지 않습니다 — 공유 토글은 URL에 실리면 링크를 받은 사람의
 * 화면까지 등록시키고, 열림 상태는 링크로 재현할 이유가 없습니다.
 *
 * 공유는 **기본 켜짐**입니다. 진단은 "지금 보고 있는 것"을 묻는 기능이고,
 * 좌표가 없으면 상류는 답 대신 어느 네임스페이스인지 되묻습니다 — 기본 꺼짐은
 * 그 되묻기를 기본 동작으로 만들었습니다. 공유되는 값은 이 사용자 자신의 화면
 * 좌표뿐이고, 등록도 조회도 자기 토큰의 주체 하나에 매입니다. 끈 선택은
 * 브라우저에 남고, localStorage를 읽지 못하는 브라우저(사생활 모드·차단)에서는
 * 켜진 채로 동작합니다.
 */
const SHARE_KEY = "k8sdiag.share";

function storedShare(): boolean {
  try {
    return localStorage.getItem(SHARE_KEY) !== "off";
  } catch {
    return true;
  }
}

interface DiagnoseUI {
  open: boolean;
  share: boolean;
  setOpen: (open: boolean) => void;
  setShare: (share: boolean) => void;
}

export const useDiagnoseUI = create<DiagnoseUI>((set) => ({
  open: false,
  share: storedShare(),
  setOpen: (open) => set({ open }),
  setShare: (share) => {
    try {
      localStorage.setItem(SHARE_KEY, share ? "on" : "off");
    } catch {
      /* 선택이 남지 않을 뿐입니다. */
    }
    set({ share });
  },
}));
